module.exports = "<nav-bar *ngIf=\"!isLoggedIn\"></nav-bar>\r\n<app-loader *ngIf=\"isLoading\"></app-loader>\r\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/pages/pages.component.html
// module id = ../../../../../src/app/pages/pages.component.html
// module chunks = main